<template>
  <span>
    <span class="loading" v-if="$apollo.queries.pipe.loading">
      <span data-uk-spinner></span>
      <span class="uk-margin-small-left uk-text-small uk-text-middle">Lade Pfeifen...</span>
    </span>
    <span v-if="s.numChildren === 0">{{s.remark}}</span>
    <span v-else>
      <svg v-if="!$apollo.queries.pipe.loading" class="svg-pipes" width="1450" height="25">
        <pattern id="sponsor-1500" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#768e53; stroke-width:1;" ></path>
        </pattern>
        <pattern id="sponsor-1000" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#bbd0a1; stroke-width:1;" ></path>
        </pattern>
        <pattern id="sponsor-500" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#3d668f; stroke-width:1;" ></path>
        </pattern>
        <pattern id="sponsor-250" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#6a98b9; stroke-width:1;" ></path>
        </pattern>
        <pattern id="sponsor-100" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#aac4d4; stroke-width:1;" ></path>
        </pattern>
        <pattern id="sponsor-50" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)" width="4" height="4">
          <path d="M-1,1 l2,-2
                   M0,4 l4,-4
                   M3,5 l2,-2"
                style="stroke:#f5c177; stroke-width:1;" ></path>
        </pattern>

        <pipe-rect v-for="(p, pIdx) in pipeSearch(s.id)" :s="s" :p="p" :pIdx="pIdx" v-bind:key="p.id"/>
      </svg>
    </span>
  </span>
</template>
<script>
import {PIPES_SEARCH_QUERY} from '../constants/graphql'
import PipeRect from './PipeRect'

export default {
  name: 'pipes-register-svg',
  components: {PipeRect},
  data () {
    return {
      pipe: {},
      pipe_search_selector: ''
    }
  },
  props: {
    s: {},
    tone: {}
  },
  methods: {
    pipeSearch (parentId) {
      this.pipe_search_selector = 'parent.id=' + parentId.toString()
      return this.pipe.list
    },
    refresh () {
      this.$apollo.queries.pipe.refetch()
    }
  },
  apollo: {
    pipe: {
      query: PIPES_SEARCH_QUERY,
      variables () {
        return {
          selector: this.pipe_search_selector
        }
      },
      skip () {
        return !this.pipe_search_selector
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .loading {
    vertical-align: middle;
    .uk-spinner {
      svg {
        width: 15px;
        height: 15px;
      }
    }
  }
  a.uk-icon {
    position: absolute;
    margin-left: -25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PipesRegisterSvg.vue